import { useState } from "react";
import { toast } from "sonner";
import { Heart, Loader2 } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export const FollowButton = () => {
  const { stats, followed, doFollow } = useSettings();
  const [busy, setBusy] = useState(false);

  const click = async () => {
    if (followed) {
      toast("You're already following 🙏");
      return;
    }
    setBusy(true);
    try {
      await doFollow();
      toast.success("Thank you for following!");
    } catch {
      toast.error("Could not follow right now");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      data-testid="follow-button"
      onClick={click}
      disabled={busy}
      className="group inline-flex items-center gap-2 px-6 py-3 rounded-full border border-gold/50 bg-gold/10 text-parchment font-semibold hover:bg-gold/20 transition-colors disabled:opacity-60"
    >
      {busy ? (
        <Loader2 size={18} className="animate-spin" />
      ) : (
        <Heart size={18} className={followed ? "fill-gold-light text-gold-light" : ""} />
      )}
      {followed ? "Following" : "Follow"}
      <span className="ml-1 text-sm font-mono text-gold-light" data-testid="follow-count">
        {stats?.follows ?? 0}
      </span>
    </button>
  );
};
